import { getDateText, VText } from '@vake/ui-kit';
import { addReportKindSymbol } from '../../../utils/report-kind-icons';
import { FC } from 'react';

export const ReportRow: FC<AllReports> = (item) => {
    const { uuid, bucketPath, reportType, reportName, customerGroupName, createdAt } = item;
    const handleClick = () => {
        let url = '';
        if (reportType === 'Overwatch') {
            url = 'https://www.vake.ai/v2/overwatch/' + uuid;
        } else {
            const path = bucketPath ? bucketPath : uuid;
            const root = bucketPath ? 'https://www.vake.ai/pathfinder' : 'https://pathfinder.vake.ai';
            url = `${root}/${path}`;
        }
        window.open(url, '_blank');
    };
    return (
        <tr className="cursor-pointer" onClick={handleClick}>
            <td className="pr-4 block" title={reportName}>
                <VText className="flex items-center gap-2 ">
                    <span className="w-4">{addReportKindSymbol(reportType.toLowerCase())}</span>
                    <span className="min-w-0 truncate">{reportName}</span>
                </VText>
            </td>
            <td>
                <VText>{getDateText(createdAt)}</VText>
            </td>
            <td>
                <VText>{reportType}</VText>
            </td>
            <td>
                <VText>{customerGroupName}</VText>
            </td>
            <td>
                <VText>{uuid ? 'true' : 'false'}</VText>
            </td>
        </tr>
    );
};
